class HbVideoFile extends HbElements.Component {
  onConnect() {
    this.video = this.querySelector('video');
    if (!this.video) return;

    this.autoplay = this.boolAttr('autoplay');
    if (!this.autoplay) return;

    this.play = this.play.bind(this);
    this.video.addEventListener('loadeddata', this.play);

    if ('IntersectionObserver' in window) {
      this.observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) this.play();
            else this.video.pause();
          });
        },
        { threshold: 0.15 }
      );
      this.observer.observe(this.video);
    }

    // Browsers that hold playback until the visitor has interacted with the page.
    this.gestureEvents = ['pointerdown', 'touchstart', 'scroll'];
    this.gestureEvents.forEach((name) => {
      document.addEventListener(name, this.play, { passive: true });
    });

    this.play();
  }

  play() {
    if (!this.video) return;
    this.video.muted = true;
    const played = this.video.play();
    if (played && played.catch) played.catch(() => {});
  }

  onDisconnect() {
    if (this.observer) {
      this.observer.disconnect();
      this.observer = null;
    }
    if (this.video) this.video.removeEventListener('loadeddata', this.play);
    if (this.gestureEvents) {
      this.gestureEvents.forEach((name) => document.removeEventListener(name, this.play));
    }
    this.video = null;
  }
}

HbElements.define('hb-video-file', HbVideoFile);
